export default {
      id: "oc-res-notification-usage",
      viewBox: "0 0 1131 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-notification",
      toString: function () {
        return this.url;
      }
    }